// src/components/Footer.jsx
import { Link } from "react-router-dom";
import Logo from "./Logo";

function SocialIcon({ path, label }) {
  return (
    <svg viewBox="0 0 24 24" className="w-5 h-5" aria-label={label}>
      <path d={path} fill="currentColor" />
    </svg>
  );
}

const ICONS = {
  facebook: "M22 12a10 10 0 1 0-11.6 9.9v-7h-2v-3h2v-2.3c0-2 1.2-3.1 3-3.1.9 0 1.9.2 1.9.2v2.1h-1.1c-1.1 0-1.5.7-1.5 1.4V12h2.5l-.4 3h-2.1v7A10 10 0 0 0 22 12Z",
  // ajoute les autres icônes si nécessaire
};

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-950 text-white relative overflow-hidden">
      {/* Effets de fond décoratifs */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-blue-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-blue-500 rounded-full blur-3xl"></div>
      </div>

      <div className="mx-auto container-padded py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-12 relative">

          {/* Logo net au-dessus du conteneur */}
          <div className="md:col-span-5 relative">
            <div className="absolute -top-10 left-6 w-16 h-16 z-20">
              <Logo className="w-full h-full" />
            </div>

            {/* Conteneur flou / fond semi-transparent */}
            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 shadow-xl mt-12 relative z-10">
              <h3 className="text-xl font-bold text-blue-100 mb-2">2S-PAY</h3>
              <p className="text-blue-200 leading-relaxed mb-6">
                Simplifier vos transactions immobilières avec une approche moderne et transparente.
              </p>

              {/* Réseaux sociaux */}
              <div className="flex gap-3">
                <a 
                  href="https://www.facebook.com/profile.php?id=61581773910576"
                  aria-label="Facebook"
                  className="bg-blue-500/20 backdrop-blur-sm p-3 rounded-xl hover:bg-blue-400 hover:scale-110 transition-all duration-300 border border-blue-400/30 group"
                >
                  <SocialIcon path={ICONS.facebook} label="Facebook" />
                </a>
              </div>
            </div>
          </div>

          {/* Section Liens utiles */}
          <div className="md:col-span-7">
            <div className="bg-white/5 backdrop-blur-sm p-6 rounded-2xl border border-white/10">
              <h3 className="font-bold text-lg text-blue-100 mb-6 flex items-center gap-2">
                <span className="w-1 h-6 bg-blue-400 rounded-full"></span>
                Liens utiles
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {[
                  { to: "/contact", label: "Contactez-nous" },
                  { to: "/apropos", label: "À propos" },
                  { to: "/politique-confidentialite", label: "Politique de confidentialité" },
                  { to: "/cgu", label: "Conditions Générales d'Utilisation (CGU)" },
                  { to: "/cgv", label: "Conditions Générales de Vente (CGV)", full: true },
                ].map((link, idx) => (
                  <Link
                    key={idx}
                    to={link.to}
                    className={`group flex items-center gap-3 p-3 rounded-xl hover:bg-blue-500/20 transition-all duration-300 border border-transparent hover:border-blue-400/30 ${
                      link.full ? "sm:col-span-2" : ""
                    }`}
                  >
                    <span className="w-2 h-2 bg-blue-400 rounded-full group-hover:scale-150 transition-transform"></span>
                    <span className="text-blue-100 group-hover:text-white font-medium">{link.label}</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Ligne décorative */}
        <div className="my-8 h-px bg-gradient-to-r from-transparent via-blue-400/50 to-transparent"></div>

        {/* Copyright */}
        <div className="text-center">
          <p className="text-blue-200/80 text-sm">
            © {new Date().getFullYear()} <span className="font-semibold text-blue-100">2S-PAY</span> — Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}
